<template>
  <router-view :key="$route.path"/>
</template>

<style lang="scss">
@import "./assets/all"
</style>
